import { Injectable } from "@angular/core";
import { Contact } from "@models/common/contact";
import { RelationshipType } from "@models/relationships/relationship-type.enum";
import BaseApiService from "@shared/services/base/base-api.service";
import { map, Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class ContactsApiService extends BaseApiService {
  createOrUpdateContact(contact: Contact, setAsPrimaryContact = false): Observable<string> {
    return this.api.post<string>(
      `${ this.apiUrl }/contacts`,
      contact,
      {
        observe: 'response',
        params: { setAsPrimaryContact }
      })
      .pipe(
        map((response) => response?.body as string)
      );
  }

  getContactList(contactIds: string[]): Observable<Contact[]> {
    return this.api.post<Contact[]>(`${ this.apiUrl }/contacts/list`, contactIds);
  }

  deleteContact(contactId: string): Observable<void> {
    return this.api.delete<void>(`${ this.apiUrl }/contacts/${ contactId }`);
  }

  getContacts(entityId: string, relationshipTypes?: RelationshipType[]): Observable<Contact[]> {
    if (relationshipTypes?.length) {
      const relationshipTypesParam = relationshipTypes.map(type => `relationshipTypes=${ type }`).join('&');
      return this.api.get<Contact[]>(`${ this.apiUrl }/contacts/${ entityId }/entity?${ relationshipTypesParam }`);
    } else {
      return this.api.get<Contact[]>(`${ this.apiUrl }/contacts/${ entityId }/entity`);
    }
  }

  getIndividualContacts(individualId: string): Observable<Contact[]> {
    return this.api.get<Contact[]>(`${ this.apiUrl }/individuals/${ individualId }/contacts`);
  }

  setIndividualPrimaryContact(individualId: string, primaryContactId: string): Observable<unknown> {
    return this.api.put(`${ this.apiUrl }/individuals/${ individualId }/set-primary-contact`, JSON.stringify(primaryContactId), {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
}
